<app-view-item *ngIf="readonly" [text]="selected?.code + ' - ' + selected?.name"></app-view-item>
<div class="ccac-select-container" *ngIf="!readonly">
  <nz-select #selector nzShowSearch nzServerSearch [nzAllowClear]="true" [nzBackdrop]="addBackdrop"
    [nzFilterOption]="nzFilterOption" (nzOnSearch)="onSearch($event)" (nzOpenChange)="onDropdownOpenChange($event)"
    (nzScrollToBottom)="loadMore()" (keydown)="handleKeyDown($event)" (click)="handleClick($event)"
    [nzCustomTemplate]="displayTpl" [(ngModel)]="value" (ngModelChange)="valueChanged($event)"
    [nzDropdownMatchSelectWidth]="false" [nzBorderless]="borderless" nzDropdownClassName="dropdownSelect"
    [nzDisabled]="disabled" class="width-100">
    <ng-template #displayTpl let-selected>
      {{ selected.nzLabel }}
    </ng-template>

    <!-- Custom Add New Button at top -->
    <nz-option *ngIf="!searching && showAddNewButton" [nzValue]="''" nzCustomContent>
      <div class="text-center" *ngIf="!this.NotShowInReport">
        <button type="button" nz-button nzType="primary" class="add-new-button" (click)="$event.stopPropagation(); onAddNewClick($event)">
          <span nz-icon nzType="plus"></span>
          {{ storedInstantData ? ' Add New \''+ storedInstantData +'\'' : ' Add New' }}
        </button>
      </div>
    </nz-option>

    <ng-container *ngFor="let o of list">
      <nz-option *ngIf="!searching" [nzValue]="getValue(o)" [nzLabel]="o.code + ' - ' + o.name" nzCustomContent>
        <div><strong>{{ o.code }}</strong></div>
        <div><small>{{ o.name }}</small></div>
      </nz-option>
    </ng-container>
  </nz-select>
</div>
<app-account-code-modal #codeModal (submitted)="onSubmit($event)" [initSpecialCode]="'CCAC'"></app-account-code-modal>